<form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-datepicker
                #dtStartDate
                formControlName="startDate"
                appendTo="body"
                [yearNavigator]="true"
                [monthNavigator]="true"
                [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "
            ></p-datepicker>
            <label for="float-dd">Start Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-datepicker
                #dtEndDate
                formControlName="endDate"
                appendTo="body"
                [yearNavigator]="true"
                [monthNavigator]="true"
                [yearRange]="
                    moment().add(-10, 'year').format('YYYY') +
                    ':' +
                    moment().add(10, 'year').format('YYYY')
                "
            ></p-datepicker>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-multiSelect
                class="filter"
                formControlName="contracts"
                [maxSelectedLabels]="1"
                selectedItemsLabel="{0} Contracts/CNs selected"
                [options]="Contracts"
                [filter]="true"
                appendTo="body"
                [style]="{ 'min-width': '15em' }"
            >
            </p-multiSelect>
            <label for="float-dd">Filter Contract/CN</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <input
                pInputText
                title="Filter Invoice"
                type="text"
                formControlName="invoiceNumber"
            />
            <label for="float-dd">Filter Invoice Number</label>
        </p-floatLabel>
    </p-toolbar>
</form>
